<template>
    <div class="o-layout o-layout--center">
        <div class="c-panel">

            <h2 class="margin-b-8">Wachtwoord vergeten</h2>

            <p>Vul hieronder je e-mailadres in. We sturen dan binnen enkele minuten een e-mail waarmee een nieuw wachtwoord kan worden aangemaakt.</p>

            <c-form ref="form" @valid="submit" :autocomplete="'off'">

                <c-form-element
                    :label="'E-mailadres'">
                    <input type="email" v-model="email" required name="email" autocomplete="email" />
                </c-form-element>

                <p class="color-alert" v-if="error">Helaas konden we je geen e-mail versturen.</p>

                <button type="submit" class="c-btn c-btn--expanded margin-t-32" ref="submit">Verzenden</button>

                <div class="text-center">
                    <router-link :to="{name: 'login'}">Terug naar inloggen</router-link>
                </div>

            </c-form>

        </div>
    </div>
</template>

<script>
    import Form from '@mixins/Form';

    export default {
        mixins: [ Form ],
        data() {
            return {
                error: false,
                email: '',
            }
        },
        methods: {
            submit() {
                this.error = false;

                this.$xhr.post('/api/auth/password-recover/', { email: this.email }).then( () => {
                    this.$router.push({name: 'password-forget-success'});
                }).catch( () => {
                    this.error = true;
                });
            }
        }
    }
</script>
